{
    "RunondayMonthLabel": "Run On Day (Month):",
    "RunondayWeekLabel": "Run On Day (Week):",
    "RunondaysLabel": "Run Report On Days:",
    "RunbetweenhoursStartLabel": "Run Between Hours:",
    "RunbetweenhoursEndLabel": "And:",
    "RunbetweenhoursNote": "(Inclusive On Entire Ending Hour)",
    "RunatminuteHourLabel": "Run At Minute (Hour):",
    "RunatminuteHourNote": "Past Every Hour (Approximate)",
    "RunondateLabel": "Run Report On Date:",
    "RunattimeLabel": "Run At Time (Approx):",
    "NAME": "TimeOptions",
    "TimeOptions_SectionHeader": "Time Options"
}